import React from 'react';
import PropTypes from 'prop-types';
import { faFile, faExclamation } from '@fortawesome/pro-solid-svg-icons';

import PageHeader from 'components/page_header';

import FileSystem from 'components/file_system';
import rootFolder from './sample_data/root_folder';
import { findIndex } from 'lodash';

export default class FileSystemSample extends React.Component {
  static propTypes = {
    styleGuidePath: PropTypes.string.isRequired
  }

  state = {
    navigation: [rootFolder],
    file: null,
    sort: {
      field: null,
      reverse: false
    }
  }

  allSelected = () => this.currentFolder().children.every(child => child.selected)

  selectAllFiles = () => {
    const selected = this.allSelected();
    this.currentFolder().children.forEach((file) => {
      file.selected = !selected;
    });
    this.forceUpdate();
  }

  keyForFile = file => file.folder ? `folder${file.id}` : `file${file.id}`;

  handleFileRename = (file, newName) => {
    this.currentFolder().children.find(child => child == file).name = newName;
  }

  handleFileSelect = (file) => {
    file = this.currentFolder().children.find(child => child == file);
    file.selected = !file.selected;
    this.forceUpdate();
  }

  handlePreview = (file) => {
    this.setState({ file });
  }

  exitPreview = () => {
    this.setState({ file: null });
  }

  handleNavigation = (folder) => {
    this.setState((prevState) => {
      const indexInStack = findIndex(this.state.navigation, { id: folder.id });

      if (indexInStack >= 0) {
        return { navigation: prevState.navigation.slice(0, indexInStack + 1) };
      } else {
        return { navigation: [...prevState.navigation, folder] };
      }
    });
  }

  handleHeaderClick = (key) => {
    if (!key) return;
    this.setState((state) => {
      const { sort } = { ...state };
      if (sort.field == key) {
        sort.reverse = !sort.reverse;
      } else {
        sort.reverse = false;
        sort.field = key;
      }
      return { sort };
    });
  }

  currentFolder() {
    return this.state.navigation[this.state.navigation.length - 1];
  }

  sortedChildren() {
    const { children } = this.currentFolder();
    const { sort } = this.state;
    if (!sort.field) return children;

    const sorted = children.sort((a, b) => {
      return (a[sort.field] || '').localeCompare(b[sort.field] || '', 'en', { sensitivity: 'base' });
    });
    return sort.reverse ? sorted.reverse() : sorted;
  }

  sampleActions = () => {
    return [{ label: 'Alert', key: 'alert', icon: faExclamation, callback: () => alert('Action Clicked') }];
  }

  renderCurrentItems() {
    return this.sortedChildren().map((item, idx) => {
      return (
        <FileSystem.Row
          actions={this.sampleActions()}
          file={item}
          index={idx}
          key={this.keyForFile(item)}
          onNavigation={this.handleNavigation}
          onPreview={this.handlePreview}
          onRename={this.handleFileRename}
          onSelect={this.handleFileSelect}
        />
      );
    });
  }

  renderBody() {
    if (this.state.file) {
      return <FileSystem.Preview file={this.state.file} onExit={this.exitPreview} />;
    }
    return (
      <React.Fragment>
        <FileSystem.Breadcrumbs folders={this.state.navigation} onNavigation={this.handleNavigation} />
        <FileSystem.Table
          allSelected={this.allSelected()}
          sort={this.state.sort}
          onHeaderClick={this.handleHeaderClick}
          onSelectAll={this.selectAllFiles}
        >
          {this.renderCurrentItems()}
        </FileSystem.Table>
      </React.Fragment>
    );
  }

  render() {
    return (
      <div>
        <PageHeader
          iconDescription="File Navigation"
          iconName={faFile}
          iconSize="lg"
          iconText="Files"
          iconType="icon"
        >
          <a className="btn btn-dark" href={this.props.styleGuidePath}>
            Back to Style Guide
          </a>
        </PageHeader>
        <div className="container white mt-5">
          {this.renderBody()}
        </div>
      </div>
    );
  }
}
